import CurrentUser from '../graphql/queries/CurrentUser'
import { useQuery } from '@apollo/client'

export default function useCurrentUser() {
    const { data } = useQuery(CurrentUser)
    return data?.user
}
